import {
  IPagination,
  IPagingResponse,
  IResponseT,
} from 'interface/base.interface';
import { IProduct } from 'interface/product.interface';
import axiosClient from './axiosClient';
import {
  IApprovalListPortfolio,
  IFilePortfolio,
  IPortfolioListResponse,
  IPortfolioResponse,
} from 'interface/portfolio.interface';
const path = 'abe/portfolio';

const PortfolioApi = {
  getDetail: (id: string): Promise<IPortfolioResponse> => {
    return axiosClient.get(`/${path}/get-by-id?id=${id}`);
  },
  getProducts: (
    pof_code: string,
    params?: IPagination
  ): Promise<IPagingResponse<IProduct>> => {
    return axiosClient.get(`/${path}/get-product?pof_code=${pof_code}`, {
      params,
    });
  },
  getApprovalDetail: (
    code: string
  ): Promise<IResponseT<IApprovalListPortfolio>> => {
    return axiosClient.get(`/${path}/get-approve-detail?pof_code=${code}`);
  },
  getListFile: (id?: number): Promise<IResponseT<IFilePortfolio[]>> => {
    return axiosClient.get(`/${path}/get-list-file?pof_id=${id}`);
  },
  post: (data: any): Promise<any> => {
    return axiosClient.post(`/${path}`, data);
  },
  put: (data: any): Promise<any> => {
    return axiosClient.put(`/${path}`, data);
  },
  uploadFile: (data: any): Promise<any> => {
    return axiosClient.post(`/${path}/upload-file`, data);
  },
  insertApproveDetail: (data: any): Promise<any> => {
    return axiosClient.post(`/${path}/insert-approve-detail`, data);
  },
  getAll: (params?: any): Promise<IPortfolioListResponse> => {
    return axiosClient.get(`/${path}`, { params });
  },
  search: (
    pof_type_code: string,
    pof_name: string,
    params?: IPagination
  ): Promise<IPortfolioListResponse> => {
    return axiosClient.get(
      `/${path}?pof_type_code=${pof_type_code}&pof_name=${pof_name}`,
      { params }
    );
  },
  searchByStatus: (
    status: number,
    pof_type_code: string,
    pof_name: string,
    params?: IPagination
  ): Promise<IPortfolioListResponse> => {
    return axiosClient.get(
      `/${path}?is_not_expired=true&pof_type_code=${pof_type_code}&pof_name=${pof_name}&status=${status}`,
      { params }
    );
  },

  getProductByPofCode: (
    pof_codes: string[],
    params?: IPagination
  ): Promise<IPagingResponse<IProduct>> => {
    return axiosClient.get(
      `/${path}/get-product-template-by-pof-code?pof_codes=${JSON.stringify(
        pof_codes
      )}`,
      {
        params,
      }
    );
  },

  getApproveSettings: (params?: any) => {
    return axiosClient.get(`/abe/pof-setting-approve/get-many`, { params });
  },

  requestCategoryApprove: (id: any) => {
    return axiosClient.put(`/${path}/request-approve/${id}`);
  },

  getlogApprove: (id: any): Promise<any> => {
    return axiosClient.get(
      `/${path}/list-log-approve?portfolio_id=${id}&order_by=created_at&order_type=DESC`
    );
  },
};

export default PortfolioApi;
